import utils from '@/utils'

const LIST_PARAMS_KEY = 'student:listParams'

export const student = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
    listParams: JSON.parse(localStorage.getItem(LIST_PARAMS_KEY)),
    searchList: {
      data: [],
      meta: {},
    },
    searchListLoading: false,
    privateTeachers: [],
    privateTeachersLoading: false,
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
    listParams: (state) => {
      return state.listParams
    },
    searchList: (state) => {
      return state.searchList
    },
    isSearchListLoading: (state) => {
      return state.searchListLoading
    },
    privateTeachers: (state) => {
      return state.privateTeachers
    },
    isPrivateTeachersLoading: (state) => {
      return state.privateTeachersLoading
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
    setListParams(state, data) {
      localStorage.setItem(LIST_PARAMS_KEY, JSON.stringify(data))
    },
    setSearchList(state, data) {
      state.searchList = data
    },
    setSearchListLoading(state, data) {
      state.searchListLoading = data
    },
    setPrivateTeachers(state, data) {
      state.privateTeachers = data
    },
    setPrivateTeachersLoading(state, data) {
      state.privateTeachersLoading = data
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/students`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'student/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async search({ commit, dispatch }, { search, filters }) {
      commit('setSearchListLoading', true)
      try {
        const response = await axios.get(`/api/students`, {
          params: {
            name: search,
            ...filters,
          },
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setSearchList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'student/search', error },
          { root: true }
        )
      } finally {
        commit('setSearchListLoading', false)
      }
    },
    async getDetail({ commit }, id) {
      commit('setDetailLoading', true)
      const response = await axios.get(`/api/students/${id}`)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async create({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.post('/api/students', data)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async update({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.put(`/api/students/${data.id}`, data)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async delete({ commit }, id) {
      commit('setDeleteLoading', true)
      await axios.delete(`/api/students/${id}`)
      commit('setDeleteLoading', false)
    },
    async getPrivateTeachers({ commit, dispatch }, { search, filters }) {
      commit('setPrivateTeachersLoading', true)
      try {
        const response = await axios.get(`/api/teachers`, {
          params: {
            name: search,
            ...filters,
          },
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setPrivateTeachers', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'student/privateTeachers', error },
          { root: true }
        )
      } finally {
        commit('setPrivateTeachersLoading', false)
      }
    },
  },
}
